export default __webpack_public_path__ + "static/media/a016-attention-market.e3d625d1.svg";